/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Matomo goal ids for the conversions the server reports. Goal ids are per-Matomo-instance, so they are configured alongside the site id. A conversion with no configured goal id is not tracked.
 * @export
 * @interface AnalyticsGoals
 */
export interface AnalyticsGoals {
    /**
     * 
     * @type {number}
     * @memberof AnalyticsGoals
     */
    registration?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyticsGoals
     */
    subscription?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyticsGoals
     */
    booking_ppu?: number;
}

/**
 * Check if a given object implements the AnalyticsGoals interface.
 */
export function instanceOfAnalyticsGoals(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AnalyticsGoalsFromJSON(json: any): AnalyticsGoals {
    return AnalyticsGoalsFromJSONTyped(json, false);
}

export function AnalyticsGoalsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalyticsGoals {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'registration': !exists(json, 'registration') ? undefined : json['registration'],
        'subscription': !exists(json, 'subscription') ? undefined : json['subscription'],
        'booking_ppu': !exists(json, 'booking_ppu') ? undefined : json['booking_ppu'],
    };
}

export function AnalyticsGoalsToJSON(value?: AnalyticsGoals | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'registration': value.registration,
        'subscription': value.subscription,
        'booking_ppu': value.booking_ppu,
    };
}

